export * from "./actions/getNativeBalance";
export * from "./actions/transferNative";
export * from "./actions/listAccounts";
export * from "./actions/walletInfo";
export * from "./actions/deployPrivateErc721Contract";
export * from "./actions/mintPrivateErc721Token";
export * from "./actions/transferPrivateErc721Token";
export * from "./actions/getPrivateErc721TokenUri";
export * from "./actions/deployPrivateErc20Contract";
export * from "./actions/mintPrivateErc20Token";
export * from "./actions/getPrivateErc20Balance";
export * from "./actions/transferPrivateErc20Token";
export * from "./actions/listCarbonPools";
export * from "./actions/swap";
export * from "./providers/cotiProvider";
export * from "./providers/wallet";
export * from "./types/index";

import { Plugin, logger } from "@elizaos/core";
import { getNativeBalanceAction } from "./actions/getNativeBalance";
import { transferNativeAction } from "./actions/transferNative";
import { listAccountsAction } from "./actions/listAccounts";
import { walletInfoAction } from "./actions/walletInfo";
import { deployPrivateERC721ContractAction } from "./actions/deployPrivateErc721Contract";
import { mintPrivateErc721TokenAction } from "./actions/mintPrivateErc721Token";
import { transferPrivateErc721TokenAction } from "./actions/transferPrivateErc721Token";
import { getPrivateErc721TokenUriAction } from "./actions/getPrivateErc721TokenUri";
import { deployPrivateErc20ContractAction } from "./actions/deployPrivateErc20Contract";
import { mintPrivateErc20TokenAction } from "./actions/mintPrivateErc20Token";
import { getPrivateErc20BalanceAction } from "./actions/getPrivateErc20Balance";
import { transferPrivateErc20TokenAction } from "./actions/transferPrivateErc20Token";
import { listCarbonPoolsAction } from './actions/listCarbonPools';
import { swapAction } from './actions/swap';
import { cotiProvider } from "./providers/cotiProvider";
import { cotiWalletProvider } from "./providers/wallet";

// Simple test action to verify plugin is working
const testAction = {
    name: "TEST_COTI_PLUGIN",
    similes: ["TEST_COTI", "COTI_TEST", "HELLO_COTI"],
    description: "Test action to verify COTI plugin is working",
    validate: async (_runtime: any, message: any) => {
        const text = message.content?.text || "";
        logger.info("🧪 TEST_COTI_PLUGIN validation called with text:", text);
        const shouldTest = /\b(test|hello).*\b(coti|plugin)\b/i.test(text);
        logger.info("🧪 Should test:", shouldTest);
        return shouldTest;
    },
    handler: async (_runtime: any, message: any, _state: any, _options: any, callback: any) => {
        logger.info("🧪 TEST_COTI_PLUGIN handler called!");
        logger.info("🧪 Message text:", message.content?.text);
        if (callback) {
            await callback({
                text: "✅ COTI Plugin is working! All actions are loaded successfully. Your ERC20 deployment should work too!",
                content: { success: true }
            });
        }
        return { text: "COTI Plugin test successful", success: true };
    },
    examples: []
};

// Debug logging to verify actions are loaded
logger.info("🚀 Loading plugin-coti with actions:", {
    actions: [
        "GET_NATIVE_BALANCE",
        "TRANSFER_NATIVE",
        "LIST_ACCOUNTS",
        "WALLET_INFO",
        "DEPLOY_PRIVATE_ERC721_CONTRACT",
        "MINT_PRIVATE_ERC721_TOKEN",
        "TRANSFER_PRIVATE_ERC721_TOKEN",
        "GET_PRIVATE_ERC721_TOKEN_URI",
        "DEPLOY_PRIVATE_ERC20_CONTRACT",
        "GET_PRIVATE_ERC20_BALANCE",
        "TRANSFER_PRIVATE_ERC20_TOKEN",
        "LIST_CARBON_POOLS",
        "SWAP"
    ]
});

// Verify all actions are properly imported
logger.info("🔍 Verifying action imports:", {
    getNativeBalanceAction: !!getNativeBalanceAction?.name,
    transferNativeAction: !!transferNativeAction?.name,
    listAccountsAction: !!listAccountsAction?.name,
    walletInfoAction: !!walletInfoAction?.name,
    deployPrivateERC721ContractAction: !!deployPrivateERC721ContractAction?.name,
    mintPrivateErc721TokenAction: !!mintPrivateErc721TokenAction?.name,
    transferPrivateErc721TokenAction: !!transferPrivateErc721TokenAction?.name,
    getPrivateErc721TokenUriAction: !!getPrivateErc721TokenUriAction?.name,
    deployPrivateErc20ContractAction: !!deployPrivateErc20ContractAction?.name,
    mintPrivateErc20TokenAction: !!mintPrivateErc20TokenAction?.name,
    getPrivateErc20BalanceAction: !!getPrivateErc20BalanceAction?.name,
    transferPrivateErc20TokenAction: !!transferPrivateErc20TokenAction?.name,
    listCarbonPoolsAction: !!listCarbonPoolsAction?.name,
    swapAction: !!swapAction?.name,
});

const plugin: Plugin = {
    name: "plugin-coti",
    description: "COTI blockchain plugin for Eliza OS - enables private token operations and encrypted transactions on the COTI network",
    actions: [
        testAction,
        getNativeBalanceAction,
        transferNativeAction,
        listAccountsAction,
        walletInfoAction,
        deployPrivateERC721ContractAction,
        mintPrivateErc721TokenAction,
        transferPrivateErc721TokenAction,
        getPrivateErc721TokenUriAction,
        deployPrivateErc20ContractAction,
        mintPrivateErc20TokenAction,
        getPrivateErc20BalanceAction,
        transferPrivateErc20TokenAction,
        listCarbonPoolsAction,
        swapAction,
    ],
    providers: [cotiProvider, cotiWalletProvider],
    evaluators: [],
    services: [],
};

logger.info("✅ plugin-coti exported successfully with", {
    actionsCount: plugin.actions?.length || 0,
    providersCount: plugin.providers?.length || 0,
    actionNames: plugin.actions?.map((action: any) => action.name) || []
});

export { plugin };
export default plugin;
